export default __webpack_public_path__ + "static/TCP-ac9118b6b6347edd284673d254696733.png";